import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class MessageClaraDraftSource extends BaseEntityModel {
  sourceId?: string;
  kind?: string;
  title?: string;
  excerpt?: string;

  constructor(model: Partial<MessageClaraDraftSource> = {}) {
    super(model);

    this.sourceId = model.sourceId;
    this.kind = model.kind;
    this.title = model.title;
    this.excerpt = model.excerpt;
  }
}
